import { FormlyFieldConfig } from "@ngx-formly/core";

export const IntestatarioTipo: FormlyFieldConfig[] = [
    {
      "fieldGroup": [
          {
              "key": 'intestatario.tipo',
              "type": 'mat-radio',
              "defaultValue":'fisica',
              "props": {
                  "label": "TIPO DI INTESTATARIO",
                  "options": [
                      { "value": 'fisica', "label": "L'INTESTATARIO DELL'ISTANZA È UNA PERSONA FISICA" },
                      { "value": 'giuridica', "label": "L'INTESTATARIO DELL'ISTANZA È UNA PERSONA GIURIDICA (società, ditta, associazione....)" },
                  ],
                  "color":'primary',
                  "required": true,
                  "change": (field)=>field.parent.get('intestatario.giuridica_opt').formControl.setValue(field.formControl.value=='giuridica')
              }
          }
      ]
  }
  ]
